<template>
  <div class="video-card" :class="{ 'flex-row-reverse': revert }">
    <div class="video-content">
      <h2 class="title">{{ data.title }}</h2>
      <p v-if="data.desc" class="desc">{{ data.desc }}</p>
      <div v-if="data.sub_title" class="sub-title">{{ data.sub_title }}</div>
      <ul v-if="displayList.length > 0" class="detail">
        <li v-for="(item, idx) in displayList" :key="idx" class="detail-item">
          <p class="detail-title">{{ item.title }}</p>
          <p class="detail-content">{{ item.content }}</p>
        </li>
      </ul>
    </div>
    <div class="w-[40px]"></div>
    <div class="media-player">
      <Resource
        class="video-bg"
        :src="
          isChinese()
            ? getFeUrl('/youyan-platform/png/scenarios/union.png')
            : getFeUrl('/rendora/scenarios/union.png')
        "
        :transform-resource="transformImage"
      />
      <div
        v-if="
          data?.template?.tags?.includes($t('re-men')) &&
          !data?.template?.is_new
        "
        class="fire"
      >
        <iconpark-icon
          name="hot-tag"
          size="56"
          class="h-[22px]"
        ></iconpark-icon>
      </div>
      <div v-if="!data?.template?.is_new" class="new">
        <iconpark-icon
          name="high-new"
          size="40"
          class="absolute top-[0px] right-[10px] z-10"
        ></iconpark-icon>
      </div>
      <Media
        :template="data.template"
        :hover-video="data.template.preview_video"
      />
    </div>
  </div>
</template>
<script lang="ts" setup>
import Media from './media'
import type {
  ScenariosConfigDataCard,
  ScenariosTemplateConfig,
} from '~/api/interface/scenarios'

interface CardProps {
  data: ScenariosConfigDataCard
  revert?: boolean
}

const props = defineProps<CardProps>()

const displayList = computed(() => props.data.list as ScenariosTemplateConfig[])
</script>
<style lang="scss" scoped>
.video-card {
  display: flex;
  height: 100%;
  width: 100%;
  padding-top: 20px;
  &.flex-row-reverse {
    .media-player .video-bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      z-index: 0;
      transform: translate(-20px, -20px);
    }
  }
  .media-player {
    position: relative;
    width: 640px;
    height: 337px;
    border-radius: 12px;
    &:deep(video) {
      position: absolute;
      top: 0;
    }
    .video-bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      z-index: 0;
      transform: translate(20px, -20px) scaleX(-1);
    }
  }
  .fire {
    position: absolute;
    left: 10px;
    top: 10px;
    color: var(--error-6);
    z-index: 10;
  }
  .video-content {
    width: 600px;

    p,
    h2 {
      margin: 0;
    }
    > .title {
      font-size: 20px;
      font-weight: 600;
      line-height: 28px;
      color: var(--text-1);
      margin: 0 auto 12px;
    }
    > .desc {
      margin: 0;
      font-size: 12px;
      font-weight: 400;
      line-height: 20px;
      color: var(--text-1-60);
      margin: 0 auto 30px;
    }

    > .sub-title {
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
      color: var(--purple-6);
      margin: 0 auto 20px;
    }

    .detail-item {
      > .detail-title {
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
        color: var(--text-1);
        display: flex;
        align-items: center;
        &::before {
          display: block;
          content: ' ';
          width: 4px;
          height: 4px;
          border-radius: 50%;
          margin-right: 8px;
          background-color: var(--text-1);
        }
      }
      > .detail-content {
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
        margin: 12px auto 20px;
        color: var(--text-1-60);
      }
    }
  }
}
</style>
